import { Option, PageInfo, TableFetchData } from "@powerledger/ui-component-lib";
import React, { Dispatch, SetStateAction } from "react";

import { RECOrderAttributeOptions } from "@/app/lib/format-rec-options";
import {
  ERCOTUnSupportedColumns,
  MRETSUnSupportedColumns,
  OrderHistoryToggleColumns,
  UnSupportedColumns,
} from "@/app/lib/registry-attributes-helpers";

import { ApplyFiltersFn } from "../../components/page-header/filter/filter.types";
import { ReturnTypeFormatAttributes } from "../../lib/format-attributes";
import { OrderHistory, OrderPosition, RecAttributes, RegistryCode } from "../../types/generated/graphql";

export type OrderHistoryTableData = Omit<OrderHistory, "attributes"> & {
  attributes: RecAttributes;
} & ReturnTypeFormatAttributes;

export type OrderHistoryFilterKeys =
  | "vintage"
  | "location"
  | "eligibility"
  | "certification"
  | "fuelSource"
  | "project"
  | "status";

export interface OrderHistoryProps {
  tableData: OrderHistoryTableData[];
  loading: boolean;
  reloadOrderHistory: () => void;
  cancelOrderId: string;
  getOrderIsCancellable: (order: OrderHistoryTableData) => boolean;
  initOrderCancellation: (orderId: string) => void;
  showOrderCancelModal: boolean;
  setShowOrderCancelModal: Dispatch<SetStateAction<boolean>>;
  getCanDownloadTransactionSummary: (order: OrderHistoryTableData) => boolean;
  handleFilterChange: ApplyFiltersFn;
  typeFilter: OrderPosition;
  typeFilterChanged: (value: boolean) => void;
  fetchData: TableFetchData<OrderHistoryTableData>;
  pageInfo: PageInfo;
  recOptions?: RECOrderAttributeOptions;
  showAllAttributes: boolean;
  setShowAllAttributes: React.Dispatch<React.SetStateAction<boolean>>;
  registryCode: RegistryCode;
  orderHiddenColumn: string[];
}

export type OrderHistoryFilters = {
  location: Option | null;
  vintage: Option | null;
  eligibility: Option | null;
  fuelSource: Option | null;
  project: Option | null;
  status: Option | null;
  certification: Option | null;
};

export type OrderHistoryFilterOptions = {
  vintages: Option[];
  eligibilities: Option[];
  locations: Option[];
  fuelSources: Option[];
  projects: Option[];
  statuses: Option[];
};

export const OrderUnSupportedColumns: UnSupportedColumns = {
  [RegistryCode.Mrets]: {
    unsupportedColumns: MRETSUnSupportedColumns,
    toggleColumns: [...OrderHistoryToggleColumns, ...ERCOTUnSupportedColumns, "commencementDate"],
  },
  [RegistryCode.Ercot]: {
    unsupportedColumns: ERCOTUnSupportedColumns,
    toggleColumns: [...OrderHistoryToggleColumns, "projects", "commencementDate"],
  },
};
